import React, { useEffect, useState } from "react";
import truncate from "../../../util/truncate";
import {
  viewport,
  colors,
  font,
  lineHeight,
} from "../../../styles/cssinjs/helpers/variables.js";

export default function BlogCardsSection({ data }) {
  const [blogData, setBlogData] = useState(null);
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    fetch(data.endpoint)
      .then((res) => res.json())
      .then((data) => {
        setBlogData(data);
        setLoading(false);
      });
  }, [data.endpoint]);

  const Title = () => (
    <article className="container lg:maxw-lg block--align-center lg:text-center md:text-left">
      <h2
        className="lg:mb-4 md:mb-2 text-xl"
        dangerouslySetInnerHTML={{ __html: data.title }}
      />
      <p
        className="lg:mt-4 md:mt-2"
        dangerouslySetInnerHTML={{ __html: data.desc }}
      />
    </article>
  );

  const Card = ({ item, index }) => {
    if (item !== null) {
      return (
        <a
          className={`btn-outline bg:hover-white text-left hover-review-card px-0 py-0 blog-posts md:mb-0 md:bg-white ${
            index != 0 ? "md:mt-2.5" : ""
          }`}
          href={item.link}
        >
          <figure>
            <img
              loading="lazy"
              src={item._embedded["wp:featuredmedia"][0].link}
              alt={item._embedded["wp:featuredmedia"][0].alt_text}
              width="360"
              height="172"
            />
          </figure>
          <div className="content">
            <p className="text-grey text-xxs fw-700 mb-3 label">
              {item._embedded["wp:term"][0][0].name} — 4 min read
            </p>
            <h3 className="mb-2 lg:mt-3 md:mt-2 fw-700">
              {item.title.rendered}
            </h3>
            <p>{truncate(item.excerpt.rendered, 100)}</p>
          </div>
          <style jsx>{`
            figure,
            picture {
              width: 100%;
            }
            a {
              padding: 0;
              min-width: 295px;
              max-width: 360px;
            }
            a:hover {
              box-shadow: 0 14px 32px 0 rgb(22 45 61 / 8%),
                0 1px 4px 0 rgb(22 45 61 / 10%);
            }
            h3 {
              font-size: ${font.size.md[3]};
              line-height: ${lineHeight[8]};
            }
            img {
              border-radius: 8px;
              max-width: 360px;
              max-height: 172px;
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
            .label {
              text-transform: uppercase;
              font-size: ${font.size.sm[2]};
              line-height: ${lineHeight[5]};
            }
            .content {
              padding: 24px 24px 36px 24px;
            }
            @media (max-width: ${viewport.tablet.sm}) {
              .content {
                padding: 24px 20px;
              }
            }
          `}</style>
        </a>
      );
    }
  };

  const Cards = ({ data }) => {
    if (data !== null) {
      return (
        <>
          {data.map((item, count) => {
            return <Card key={count} item={item} index={count} />;
          })}
        </>
      );
    } else {
      return null;
    }
  };

  return (
    <section className="bg-light lg:mt-10 lg:pb-5 md:pb-5 md:mt-10">
      <Title />
      <article className="container card--default card--feature has-three-col lg:mt-10 md:mt-5">
        {!isLoading && <Cards data={blogData} />}
      </article>
    </section>
  );
}
